'use client' 

import { useState } from 'react'
import ChooseAccountSize from '@/components/ChooseAccountSize'

export default function PropFirmPage() {

  const [rulesTab, setRulesTab] = useState<'1' | '2'>('1')

  return (
    <main style={{ backgroundColor: "#000101", color: "#DBDBDB" }}>
{/* Hero */}
<section className="bg-black text-white min-h-[calc(100vh-96px)] flex items-center px-4 py-16">
  <div className="max-w-4xl mx-auto text-center">

    {/* Label */}
    <h1 className="text-sm uppercase tracking-[0.1em] text-zinc-300 mb-4 flex items-center justify-center gap-2">
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0">
    {/* Candle 1 - red */}
    <line x1="2" y1="1" x2="2" y2="3" stroke="#ef4444" strokeWidth="1"/>
    <rect x="0.5" y="3" width="3" height="5" fill="#ef4444"/>
    <line x1="2" y1="8" x2="2" y2="10" stroke="#ef4444" strokeWidth="1"/>
    {/* Candle 2 - red */}
    <line x1="6" y1="2" x2="6" y2="4" stroke="#ef4444" strokeWidth="1"/>
    <rect x="4.5" y="4" width="3" height="4" fill="#ef4444"/>
    <line x1="6" y1="8" x2="6" y2="11" stroke="#ef4444" strokeWidth="1"/>
    {/* Candle 3 - green */}
    <line x1="10" y1="4" x2="10" y2="6" stroke="#25B362" strokeWidth="1"/>
    <rect x="8.5" y="6" width="3" height="5" fill="#25B362"/>
    <line x1="10" y1="11" x2="10" y2="13" stroke="#25B362" strokeWidth="1"/>
    {/* Candle 4 - green */}
    <line x1="14" y1="3" x2="14" y2="5" stroke="#25B362" strokeWidth="1"/>
    <rect x="12.5" y="5" width="3" height="6" fill="#25B362"/>
    <line x1="14" y1="11" x2="14" y2="14" stroke="#25B362" strokeWidth="1"/>
    {/* Candle 5 - green */}
    <line x1="18" y1="1" x2="18" y2="3" stroke="#25B362" strokeWidth="1"/>
    <rect x="16.5" y="3" width="3" height="7" fill="#25B362"/>
    <line x1="18" y1="10" x2="18" y2="13" stroke="#25B362" strokeWidth="1"/>
  </svg>
  Crypto prop firm
</h1>

    {/* Headline */}
    <h2 className="text-4xl lg:text-7xl font-bold font-[family-name:var(--font-saira)] leading-tight mb-6">
    Trade crypto<br />  with our capital,<br />  not yours
    </h2>

    {/* Subheading */}
    <p className="text-zinc-400 text-sm lg:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
    Get funded crypto trading accounts up to $200,000.<br /> Keep up to 90% of profits.
    </p>

    {/* CTA */}
    <a
  href="#sizes"
  className="inline-flex items-center gap-2 border-2 border-green-500 text-green-500 px-10 py-3 text-sm uppercase tracking-widest hover:bg-green-500 hover:border-green-500 hover:text-black hover:font-bold transition-all duration-300 font-[family-name:var(--font-saira)]"
>
  Choose trading capital
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
</a>

  {/* Social proof */}
<div className="mt-10 flex justify-center">
  <div className="flex items-center gap-3 border border-zinc-800 px-4 py-3">
    <div className="flex -space-x-2 flex-shrink-0">
      {['punk0635.svg', 'punk3556.svg', 'punk7054.svg'].map((file) => (
        <img
          key={file}
          src={`/avatars/${file}`}
          alt="Crypto trader"
          className="w-8 h-8 border-2 border-black"
        />
      ))}
    </div>
    <div className="text-left">
      <p className="text-sm font-medium text-zinc-300">330+ crypto traders trust us</p>
      <p className="text-xs text-zinc-400">to access funded accounts & get paid.</p>
    </div>
  </div>
</div>

  </div>
</section>

    {/* Why trade section */}
<section className="bg-black text-white py-20 px-4 border-t border-zinc-800">
  <div className="max-w-5xl mx-auto">

    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-sm uppercase tracking-[0.1em] text-zinc-300 mb-4">Funded crypto trading accounts</h2>
      <h3 className="text-3xl lg:text-5xl font-bold font-[family-name:var(--font-saira)] leading-tight">
      Your skill. Our capital.<br />  Your profits
      </h3>
    </div>

   {/* Grid */}
<div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-zinc-800">
  {[
    {
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
      title: 'Up to $200,000',
      desc: 'Trade with institutional capital across 26+ crypto markets without risking your own money',
    },
    {
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
        </svg>
      ),
      title: 'On-demand payout',
      desc: 'Withdraw your profits in crypto anytime - no waiting periods, no fixed schedules',
    },
    {
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>
        </svg>
      ),
      title: 'Up to 90% profit split',
      desc: 'Keep the majority of every dollar you generate on your funded crypto account',
    },
    {
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        </svg>
      ),
      title: 'Fixed risk rules',
      desc: 'Drawdown limits set upfront and never moved - trade with full clarity from day one',
    },
  ].map((item, i) => (
    <div key={i} className="bg-black p-10 group hover:bg-zinc-950 transition-colors">
      <div className="w-20 h-20 border border-zinc-700 flex items-center justify-center text-[#25B362] mb-6 group-hover:border-[#25B362] transition-colors">
        {item.icon}
      </div>
      <h4 className="text-white font-bold text-xl font-[family-name:var(--font-saira)] mb-2">{item.title}</h4>
      <p className="text-zinc-400 text-sm leading-relaxed">{item.desc}</p>
    </div>
  ))}
</div>

  </div>
</section>

{/* How it works */}
<section className="bg-black text-white pt-20 pb-10 px-4 border-t border-zinc-800">
  <div className="max-w-5xl mx-auto">

    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-sm uppercase tracking-[0.1em] text-zinc-300 mb-4">The crypto prop firm process</h2>
      <h3 className="text-3xl lg:text-5xl font-bold font-[family-name:var(--font-saira)] leading-tight">
      Prove skill. Get funded.<br /> Get paid.
      </h3>
    </div>

    {/* Steps */}
    <div className="flex flex-col lg:flex-row gap-px bg-zinc-800">

      {[
        {
          number: '01',
          title: 'Choose your account size',
          desc: 'Select the trading capital that matches your experience and risk appetite.',
        },
        {
          number: '02',
          title: 'Trade under prop firm rules',
          desc: 'Hit the profit target while respecting the drawdown and daily loss limits.',
        },
        {
          number: '03',
          title: 'Get funded & withdraw',
          desc: 'Pass the challenge, receive your funded account, and request payouts anytime.',
        },
      ].map((step, i) => (
        <div key={i} className="flex-1 relative bg-black p-8 lg:p-10 group">

          {/* Top accent bar */}
          <div className="absolute top-0 left-0 right-0 h-0.5 bg-zinc-800 group-hover:bg-[#25B362] transition-colors duration-300" />

          {/* Number */}
          <p
  aria-hidden="true"
  className="text-6xl lg:text-7xl font-extrabold font-[family-name:var(--font-saira)] text-zinc-500 group-hover:text-[#25B362] transition-colors leading-none mb-6 select-none"
>
  {step.number}
</p>

          {/* Content */}
          <h4 className="text-white font-bold text-lg font-[family-name:var(--font-saira)] leading-snug mb-3">
            {step.title}
          </h4>
          <p className="text-zinc-400 text-sm leading-relaxed">
            {step.desc}
          </p>

        </div>
      ))}

    </div>

  </div>
</section>
{/* If you want to */}
<section className="bg-black text-white pt-0 pb-20 px-4">
  <div className="max-w-3xl mx-auto">

    {/* Dashed border container */}
    <div
      className="relative p-8 md:p-12"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%2325B362' stroke-width='1.5' stroke-dasharray='8%2c 6' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
      }}
    >

      {/* Title */}
      <h2 className="text-3xl lg:text-4xl font-bold font-[family-name:var(--font-saira)] text-center mb-6">
        If you want to:
      </h2>

      {/* Divider */}
      <div className="border-t border-zinc-800 mb-6" />

      {/* Checklist */}
      <ul className="mb-8 max-w-fit mx-auto">
        {[
          'Trade crypto without risking your capital',
          'Eliminate overleverage & liquidations',
          'Earn profits from funded crypto trading',
        ].map((item, i, arr) => (
          <li key={i}>
            <div className="flex items-center gap-2 py-5">
              <svg width="20" height="20" viewBox="0 0 22 22" fill="none" className="flex-shrink-0">
                <path d="M4 11.5l5 5 9-9" stroke="#25B362" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="text-sm lg:text-base font-medium text-white font-[family-name:var(--font-saira)]">
                {item}
              </span>
            </div>
            {i < arr.length - 1 && <div className="border-t border-zinc-800" />}
          </li>
        ))}
      </ul>

      {/* CTA */}
      
      <a
  href="#sizes"
  className="flex items-center justify-center gap-2 w-full border-2 border-green-500 text-green-500 py-4 text-sm uppercase tracking-widest hover:bg-green-500 hover:border-green-500 hover:text-black hover:font-bold transition-all duration-300 font-[family-name:var(--font-saira)]"
>
  Get funded now
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
</a>
      {/* Social proof */}
      <div className="mt-6 flex items-center justify-center gap-2">
      <div className="flex -space-x-2">
  {['punk0635.svg', 'punk3556.svg', 'punk7054.svg'].map((file) => (
    <img
      key={file}
      src={`/avatars/${file}`}
      alt="Crypto trader"
      className="w-9 h-9 border-2 border-black"
    />
  ))}
</div>
        <p className="text-xs text-zinc-400 leading-snug">
          330+ traders got approved<br />to trade crypto with our capital.
        </p>
      </div>

    </div>
  </div>
</section>

{/* The Founder */}
<section className="bg-black text-white py-20 px-4 border-t border-zinc-800">
  <div className="max-w-3xl mx-auto">

    {/* Title — centered */}
    <div className="text-center mb-12">
      <h2 className="text-sm uppercase tracking-[0.1em] text-zinc-300 mb-4">Who's behind Crypto Street</h2>
      <h3 className="text-3xl lg:text-5xl font-bold font-[family-name:var(--font-saira)] leading-tight">
      Meet the founder
      </h3>
    </div>

    {/* Identity row */}
    <div className="flex items-center gap-6 mb-10">

      {/* Avatar */}
      <div className="flex-shrink-0 w-20 h-20 rounded-full border-2 border-[#25B362] overflow-hidden">
        <img src="/images/alex-numeris.png" alt="Alex Numeris" className="w-full h-full object-cover" />
      </div>

      {/* Name + role */}
      <div>
        <div className="flex items-center gap-2 mb-1">
          <span className="text-xl lg:text-2xl font-bold text-white font-[family-name:var(--font-saira)]">
            Alex Numeris
          </span>
          <svg width="20" height="20" viewBox="0 0 22 22" fill="none" className="flex-shrink-0">
            <circle cx="11" cy="11" r="11" fill="#1D9BF0"/>
            <path d="M6.5 11.5l3 3 6-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <p className="text-sm text-zinc-400">Founder, Crypto Street</p>
      </div>
    </div>

    {/* Bio */}
    <div className="space-y-6 border-t border-zinc-800 pt-8">
      {[
        '11+ years trading and building in crypto markets - through bull runs, bear markets, and everything in between.',
        'Trading your own money puts a ceiling on everything. Crypto Street removes it.',
        'I built the prop firm I wished existed when I was trading my own money.',
        'If you have the skill, the only thing missing is the capital. That\'s what we provide.',   
      ].map((paragraph, i) => (
        <p key={i} className="text-base lg:text-lg text-zinc-300 leading-relaxed font-[family-name:var(--font-saira)]">
          {paragraph}
        </p>
      ))}
    </div>

  </div>
</section>

      {/* Pricing */}
      <ChooseAccountSize />

{/* Rules */}
<section className="bg-black text-white py-20 px-4 border-t border-zinc-800">
  <div className="max-w-4xl mx-auto">

    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-sm uppercase tracking-[0.1em] text-zinc-300 mb-4">Crypto prop firm rules</h2>
      <h3 className="text-3xl lg:text-5xl font-bold font-[family-name:var(--font-saira)] leading-tight">Clear rules. No surprises.</h3>
    </div>

    {/* Tab switcher */}
    <div className="flex border border-zinc-800 mb-px">
      {(['1', '2'] as const).map((tab) => (
        <button
          key={tab}
          onClick={() => setRulesTab(tab)}
          className={`flex-1 flex items-center justify-center gap-2 py-3 text-sm font-bold uppercase tracking-widest transition-all duration-300 font-[family-name:var(--font-saira)]
            ${rulesTab === tab ? 'bg-[#5841D8] text-white' : 'bg-black text-zinc-400 hover:text-zinc-300'}`}
        >
          <span className={`w-5 h-5 flex items-center justify-center text-xs border ${rulesTab === tab ? 'border-white/30' : 'border-zinc-700'}`}>{tab}</span>
          {tab === '1' ? 'One-step' : 'Two-step'}
        </button>
      ))}
    </div>

  {/* One-step rules */}
{rulesTab === '1' && (
  <div className="border border-zinc-800">
    <div className="grid grid-cols-3 lg:grid-cols-4 gap-px bg-zinc-800">
      {['Rule', 'Assessment', 'Funded', 'Notes'].map((h, i) => (
        <div key={h} className={`bg-zinc-950 px-4 py-3 ${i === 3 ? 'hidden lg:block' : ''}`}>
          <p className="text-xs uppercase tracking-[0.1em] text-zinc-400 font-[family-name:var(--font-saira)]">{h}</p>
        </div>
      ))}
    </div>
    <div className="flex flex-col gap-px bg-zinc-800">
      {[
        { rule: 'Profit target',     assessment: '9%',                        funded: 'N/A',                      notes: 'Funded account has no limit' },
        { rule: 'Max drawdown',      assessment: '6%',                        funded: '6%',                       notes: 'Equity-based, does not trail' },
        { rule: 'Daily cap limit',   assessment: '+/- 3%',                    funded: '+/- 3%',                   notes: 'Based on previous day equity' },
        { rule: 'Leverage',          assessment: '5:1 BTC/ETH · 2:1 others', funded: '5:1 BTC/ETH · 2:1 others', notes: '' },
        { rule: 'Profit share',      assessment: 'N/A',                       funded: '90%',                      notes: '' },
        { rule: 'Inactivity period', assessment: '30 days',                   funded: '30 days',                  notes: 'Must place a trade' },
        { rule: 'Max time',          assessment: 'No limit',                  funded: 'No limit',                 notes: '' },
      ].map((row, i) => (
        <div key={i} className="grid grid-cols-3 lg:grid-cols-4 gap-px bg-zinc-800">
          <div className="bg-black px-4 py-4">
            <p className="text-xs lg:text-sm text-white font-semibold font-[family-name:var(--font-saira)]">{row.rule}</p>
          </div>
          <div className="bg-black px-4 py-4">
            <p className="text-xs lg:text-sm text-zinc-300">{row.assessment}</p>
          </div>
          <div className="bg-black px-4 py-4">
            <p className="text-xs lg:text-sm text-[#25B362] font-semibold">{row.funded}</p>
          </div>
          <div className="bg-black px-4 py-4 hidden lg:block">
            <p className="text-xs text-zinc-400 leading-relaxed">{row.notes}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
)}

  {/* Two-step rules */}
{rulesTab === '2' && (
  <div className="overflow-x-auto">
    <div className="border border-zinc-800 min-w-[520px]">
      <div className="grid grid-cols-4 lg:grid-cols-5 gap-px bg-zinc-800">
        {['Rule', 'Phase 1', 'Phase 2', 'Funded', 'Notes'].map((h, i) => (
          <div key={h} className={`bg-zinc-950 px-4 py-3 ${i === 4 ? 'hidden lg:block' : ''}`}>
            <p className="text-xs uppercase tracking-[0.1em] text-zinc-400 font-[family-name:var(--font-saira)]">{h}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-px bg-zinc-800">
        {[
          { rule: 'Profit target',     p1: '6%',                        p2: '9%',                        funded: 'N/A',                      notes: 'Funded account has no limit' },
          { rule: 'Max drawdown',      p1: '9%',                        p2: '9%',                        funded: '9%',                       notes: 'Equity-based, does not trail' },
          { rule: 'Daily cap limit',   p1: '+/- 3%',                    p2: '+/- 3%',                    funded: '+/- 3%',                   notes: 'Based on previous day equity' },
          { rule: 'Leverage',          p1: '5:1 BTC/ETH · 2:1 others', p2: '5:1 BTC/ETH · 2:1 others', funded: '5:1 BTC/ETH · 2:1 others', notes: '' },
          { rule: 'Profit share',      p1: 'N/A',                       p2: 'N/A',                       funded: '90%',                      notes: '' },
          { rule: 'Inactivity period', p1: '30 days',                   p2: '30 days',                   funded: '30 days',                  notes: 'Must place a trade' },
          { rule: 'Max time',          p1: 'No limit',                  p2: 'No limit',                  funded: 'No limit',                 notes: '' },
        ].map((row, i) => (
          <div key={i} className="grid grid-cols-4 lg:grid-cols-5 gap-px bg-zinc-800">
            <div className="bg-black px-4 py-4">
              <p className="text-xs lg:text-sm text-white font-semibold font-[family-name:var(--font-saira)]">{row.rule}</p>
            </div>
            <div className="bg-black px-4 py-4">
              <p className="text-xs lg:text-sm text-zinc-300">{row.p1}</p>
            </div>
            <div className="bg-black px-4 py-4">
              <p className="text-xs lg:text-sm text-zinc-300">{row.p2}</p>
            </div>
            <div className="bg-black px-4 py-4">
              <p className="text-xs lg:text-sm text-[#25B362] font-semibold">{row.funded}</p>
            </div>
            <div className="bg-black px-4 py-4 hidden lg:block">
              <p className="text-xs text-zinc-400 leading-relaxed">{row.notes}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)}

  </div>
</section>

      {/* FAQ */}
<section id="faq" className="bg-black text-white py-20 px-4 border-t border-zinc-800">
  <div className="max-w-3xl mx-auto">

    {/* Header */}
    <div className="text-center mb-12">
      <h2 className="text-sm uppercase tracking-[0.1em] text-zinc-300 mb-4">Crypto prop firm FAQ</h2>
      <h3 className="text-3xl lg:text-5xl font-bold font-[family-name:var(--font-saira)] leading-tight">
         Questions traders ask before getting funded
      </h3>
    </div>

    <div className="flex flex-col gap-px bg-zinc-800">
      {[
        {
          q: 'What is a breach and what happens?',
          a: 'A breach means you violated the max drawdown rule. If this happens during your assessment you fail the challenge. If it happens in a funded account, the account is closed. Any gains in the account at the time of breach are still paid out to you at your profit split.',
        },
        {
          q: 'How is the max drawdown calculated?',
          a: 'The max drawdown is static - it is set at the start and does not trail upward as your account grows. For a $100,000 account with 6% drawdown, your floor is always $94,000 regardless of how high your account goes.',
        },
        {
          q: 'How does the daily cap limit work?',
          a: 'The daily cap is +/- 3% of your previous day\'s closing equity, resetting at 5 PM EST. If your account moves more than 3% in either direction, your positions are closed and the account is locked until the next trading day.',
        },
        {
          q: 'Can I hold positions over the weekend?',
          a: 'Yes. There are no restrictions on holding positions over the weekend.',
        },
        {
          q: 'How do I withdraw my profits?',
          a: 'Once funded, you can request a withdrawal at any time via your trader dashboard - 1st payment on-demand - 2nd payment every 14 or 30 days. Click "Withdraw Profits", enter the amount, and once approved the funds are paid out via available payment methods. The drawdown level does not reset after a withdrawal.',
        },
        {
          q: 'How long until I receive my funded account?',
          a: 'After passing the assessment, complete your KYC verification and sign the Trader Agreement. Your funded account is typically created and issued within 24-48 business hours after both are completed.',
        },
        {
          q: 'Can I trade during news events?',
          a: 'No. Opening a position within 3 minutes before or after a major news event is prohibited. Positions opened during news events may be closed and the associated P&L removed. Crypto Street has sole discretion in determining what qualifies as a news event.',
        },
        {
          q: 'What platform, leverage and commissions apply?',
          a: 'All trading is executed on DXtrade. Leverage is 5:1 for BTC and ETH, and 2:1 for all other cryptocurrencies. A commission of 0.05% of total notional trade volume is charged per side. Automated strategies are not supported on DXtrade.',
        },
      ].map((faq, i) => (
        <details key={i} className="group bg-black border-l-2 border-l-transparent open:border-l-[#25B362] transition-all">
          <summary className="flex items-center justify-between px-2 py-5 cursor-pointer list-none gap-4">
            <span className="text-lg font-semibold text-white font-[family-name:var(--font-saira)] group-open:text-[#25B362] transition-colors">
              {faq.q}
            </span>
            <span className="flex-shrink-0 w-5 h-5 border border-zinc-600 flex items-center justify-center group-open:border-[#25B362] transition-colors">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" className="transition-transform duration-300 group-open:rotate-45">
                <path d="M5 1v8M1 5h8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"
                  className="text-zinc-400 group-open:text-[#25B362]"/>
              </svg>
            </span>
          </summary>
          <p className="px-6 pb-6 text-sm text-zinc-400 leading-relaxed border-t border-zinc-800 pt-4">
            {faq.a}
          </p>
        </details>
      ))}
    </div>

  </div>
</section>

    </main>
  )
}